
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { TitleDropdownNavItem } from '@intellio/shared/models';
import { TranslateModule } from '@ngx-translate/core';
import {
  FeatureEnabledDirective,
  ModuleEnabledDirective,
  PermissionsRequiredDirective,
} from '../../shared-components.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'itc-title-dropdown-nav',
  templateUrl: './title-dropdown-nav.component.html',
  styleUrls: ['./title-dropdown-nav.component.scss'],
  imports: [
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule,
    RouterModule,
    MatSelectModule,
    ModuleEnabledDirective,
    PermissionsRequiredDirective,
    MatFormFieldModule,
    MatInputModule,
    FeatureEnabledDirective
],
})
export class TitleDropdownNavComponent implements OnInit, OnChanges {
  @Input() navList: TitleDropdownNavItem[];
  @Input() currentNavRoute: string;
  @Input() navStyle: string;

  currentNav: TitleDropdownNavItem;

  constructor() {}

  ngOnInit(): void {
    this.currentNav = this.navList?.find(
      (n) => n.route === this.currentNavRoute
    );
  }

  ngOnChanges(): void {
    this.currentNav = this.navList.find(
      (n) => n.route === this.currentNavRoute
    );
  }
}
